import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { ShieldCheck, ArrowRight } from "@phosphor-icons/react";

export default function Login() {
  const nav = useNavigate();
  const [email, setEmail] = useState("owner@jrllc.com");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password: pw });
      localStorage.setItem("jr_token", r.data.token);
      toast.success("Access granted");
      nav("/");
    } catch {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex flex-col bg-[#09090b] text-zinc-50">
      <header className="w-full border-b border-zinc-800/70 bg-black/60 backdrop-blur px-6 py-3 flex items-center justify-between" data-testid="landing-header">
        <div className="flex items-center gap-3">
          <div className="w-7 h-7 border border-zinc-600 grid place-items-center">
            <span className="mono text-xs font-semibold">JR</span>
          </div>
          <div className="leading-tight">
            <div className="text-sm font-semibold tracking-tight">Private Single-User Portfolio Management System</div>
            <div className="mono text-[10px] tracking-[0.2em] uppercase text-zinc-500">Jack Royals LLC · Internal Use Only</div>
          </div>
        </div>
        <div className="hidden md:flex items-center gap-2 text-[11px] mono text-zinc-500">
          <ShieldCheck size={12} /> Owner-only access · No public signup
        </div>
      </header>

      <div className="flex-1 grid grid-cols-1 lg:grid-cols-2">
        <div className="hidden lg:block relative login-bg">
        <div className="absolute inset-0 bg-black/70" />
        <div className="absolute inset-0 flex flex-col justify-between p-12 z-10">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 border border-zinc-500 grid place-items-center">
              <span className="mono text-sm font-semibold">JR</span>
            </div>
            <div>
              <div className="mono text-xs tracking-[0.2em] text-zinc-400 uppercase">Jack Royals</div>
              <div className="text-sm text-zinc-200">LLC Holdings</div>
            </div>
          </div>
          <div>
            <div className="overline mb-3">Portfolio Console</div>
            <h1 className="text-4xl font-semibold tracking-tight leading-tight">
              Private asset portfolio,<br/>on autopilot.
            </h1>
            <p className="text-zinc-400 mt-4 max-w-md">
              TX &amp; FL · Land / Residential / Commercial · Internal correspondence and record-keeping for a single principal.
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6" data-testid="login-form">
          <div>
            <div className="overline mb-3">Restricted Access</div>
            <h2 className="text-2xl font-semibold">Sign in</h2>
            <p className="text-sm text-zinc-500 mt-1">Owner-only portfolio console.</p>
          </div>

          <div className="space-y-3">
            <div>
              <label className="overline block mb-1.5">Email</label>
              <input
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-[#18181b] hairline text-zinc-100 px-3 py-2.5 mono text-sm focus:outline-none focus:border-emerald-500 rounded-sm"
                required
              />
            </div>
            <div>
              <label className="overline block mb-1.5">Password</label>
              <input
                data-testid="login-password"
                type="password"
                value={pw}
                onChange={(e) => setPw(e.target.value)}
                className="w-full bg-[#18181b] hairline text-zinc-100 px-3 py-2.5 mono text-sm focus:outline-none focus:border-emerald-500 rounded-sm"
                required
              />
            </div>
          </div>

          <button
            data-testid="login-submit"
            disabled={loading}
            className="w-full bg-emerald-500 hover:bg-emerald-400 text-black font-semibold py-2.5 px-4 rounded-sm flex items-center justify-center gap-2 transition-colors disabled:opacity-50"
            type="submit"
          >
            {loading ? "…" : (<>Enter Portfolio Console <ArrowRight size={16} weight="bold" /></>)}
          </button>

          <div className="flex items-center gap-2 text-xs text-zinc-500 mono">
            <ShieldCheck size={14} /> Encrypted session · Single operator
          </div>
        </form>
      </div>
      </div>
    </div>
  );
}
